'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function AmindSummary(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M894.56 543.968A352.16 352.16 0 0 1 704 825.632c-23.68 3.52-35.52-7.2-35.52-32.224 0-15.584 11.84-29.568 35.52-41.92A287.712 287.712 0 0 0 832 512c0-99.84-50.816-187.84-128-239.488-23.68-14.848-35.52-29.536-35.52-44.064 0-25.568 11.84-35.584 35.52-30.08a352.16 352.16 0 0 1 190.56 281.664L896 480h32a32 32 0 0 1 0 64h-32l-1.44-0.032zM128 576h416a64 64 0 0 1 64 64v192a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64v-192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h352a32 32 0 0 0 32-32v-128a32 32 0 0 0-32-32H160zM128 128h416a64 64 0 0 1 64 64v192a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h352a32 32 0 0 0 32-32V224a32 32 0 0 0-32-32H160z' })
  );
}
AmindSummary.displayName = 'AmindSummary';

module.exports = AmindSummary;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/amindSummary.js
// module id = 148
// module chunks = 0